module.exports = __webpack_public_path__ + "img/logo.adfef458.png";